module.exports = __webpack_public_path__ + "static/media/icon-festivals-parties.fa21d923.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icon-festivals-parties.svg
// module id = 2202
// module chunks = 0